/**
 * Format elapsed time in milliseconds to HH:MM:SS format
 *
 * @example
 *   formatElapsedTime(0); // "00:00:00"
 *   formatElapsedTime(1000); // "00:00:01"
 *   formatElapsedTime(61000); // "00:01:01"
 *   formatElapsedTime(3661000); // "01:01:01"
 *   formatElapsedTime(90000000); // "25:00:00"
 *
 * @param elapsedMs - Elapsed time in milliseconds
 * @returns Formatted time string in HH:MM:SS format
 */
export function formatElapsedTime(elapsedMs: number): string {
  // Handle negative or invalid values
  if (elapsedMs < 0 || !Number.isFinite(elapsedMs)) {
    return '00:00:00';
  }

  // Convert milliseconds to total seconds
  const totalSeconds = Math.floor(elapsedMs / 1000);

  // Calculate hours, minutes, seconds
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Format with leading zeros (2 digits minimum)
  const hoursStr = hours.toString().padStart(2, '0');
  const minutesStr = minutes.toString().padStart(2, '0');
  const secondsStr = seconds.toString().padStart(2, '0');

  return `${hoursStr}:${minutesStr}:${secondsStr}`;
}
